module.exports = __webpack_public_path__ + "static/media/cross.dc063ecd.svg";